var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 19 19",
    style: {
      enableBackground: "new 0 0 19 19"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.9,9.5l-7.6,7.6c-0.4,0.4-0.4,1.1,0,1.6c0.4,0.4,1.1,0.4,1.6,0l7.6-7.6l7.6,7.6c0.4,0.4,1.1,0.4,1.6,0 s0.4-1.1,0-1.6l-7.6-7.6l7.6-7.6c0.4-0.4,0.4-1.1,0-1.6c-0.4-0.4-1.1-0.4-1.6,0L9.5,7.9L1.9,0.3c-0.4-0.4-1.1-0.4-1.6,0 c-0.4,0.4-0.4,1.1,0,1.6L7.9,9.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIconWhite);
export default __webpack_public_path__ + "static/media/crossIconWhite.5c455caaccb31c29b016dea13099eeff.svg";
export { ForwardRef as ReactComponent };